import formGroupLiveLogs from './formGroupLiveLogs/formGroupLiveLogs';
import formGroupLiveStatus from './formGroupLiveLogs/formGroupLiveStatus';
import formGroupLiveAgents from './formGroupLiveLogs/formGroupLiveAgents';
import formGroupLiveMonitor from './formGroupLiveLogs/formGroupLiveMonitor';
import formGroupContentLifeCycle from './formGroupLiveLogs/formGroupContentLifeCycle';


export default {
  title: 'Live Monitoring',
  attributeName: 'liveLogs',
  // createURL: 'live/logs',
  sessionParams: [],
  getURL: 'live/logs',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: false,
  saveIdSessionNameAs: 'liveId',
  websocketChannel: 'live-liveId',
  websocketSessionParams: ['liveId'],
  websocketItems:[
      'cloud_log','ingest_log','live_log','log_link','startIngestAt','status_deployment',
      'status_live','status_cloud','status_ingest'],
  formConfig: [
    formGroupLiveStatus,
    formGroupLiveMonitor,
    formGroupContentLifeCycle,
    formGroupLiveAgents,
    formGroupLiveLogs
  ],
};
